export const FETCH_FAILURE = 'FETCH_FAILURE@fetch';
export const FETCH_REQUEST = 'FETCH_REQUEST@fetch';
export const FETCH_SUCCESS = 'FETCH_SUCCESS@fetch';